module.exports = __webpack_public_path__ + "media/images/shark/SharkSocial-p-800-87d3b8f8b07199ab9c34d18dfa298923.jpeg";